import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { GOOGLE_SIGN_IN_URL, signInErrorMessage } from '../googleSignIn';

// Google is the primary sign-in; the password form below is a fallback for
// existing staff during the rollout and will be retired
export default function Login() {
  const { staff, signingIn, signInError, login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  if (staff) return <Navigate to="/" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
      <div style={{ background: '#fff', padding: '2rem', borderRadius: '12px', border: '1px solid #e0e0e0', width: '100%', maxWidth: '380px' }}>
        <h1 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '4px' }}>ClinicDesk</h1>
        <p style={{ color: '#666', fontSize: '14px', marginBottom: '24px' }}>Patient support portal</p>
        {signInError && (
          <div role="alert" style={{ background: '#fff0f0', border: '1px solid #ffcccc', borderRadius: '8px', padding: '10px 14px', marginBottom: '16px', fontSize: '14px', color: '#c00' }}>
            {signInErrorMessage(signInError)}
          </div>
        )}
        {signingIn ? (
          <p style={{ textAlign: 'center', color: '#666', fontSize: '14px', padding: '10px' }}>Signing you in...</p>
        ) : (
          <>
            <a
              href={GOOGLE_SIGN_IN_URL}
              style={{ display: 'block', width: '100%', padding: '10px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '500', textAlign: 'center', textDecoration: 'none', boxSizing: 'border-box' }}
            >
              Sign in with Google
            </a>
            <p style={{ color: '#888', fontSize: '12px', marginTop: '14px', textAlign: 'center' }}>
              Use your @tapgp.co.uk Google account.
            </p>
            {!showPassword ? (
              <p style={{ textAlign: 'center', marginTop: '18px' }}>
                <button onClick={() => setShowPassword(true)}
                  style={{ background: 'none', border: 'none', color: '#888', fontSize: '12px', textDecoration: 'underline', cursor: 'pointer' }}>
                  Sign in with a password instead
                </button>
              </p>
            ) : (
              <form onSubmit={handleSubmit} style={{ marginTop: '18px', borderTop: '1px solid #eee', paddingTop: '16px' }}>
                {error && (
                  <div style={{ background: '#fff0f0', border: '1px solid #ffcccc', borderRadius: '8px', padding: '10px 14px', marginBottom: '14px', fontSize: '14px', color: '#c00' }}>
                    {error}
                  </div>
                )}
                <div style={{ marginBottom: '14px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '6px' }}>Email</label>
                  <input
                    type="email" value={email} onChange={e => setEmail(e.target.value)}
                    required autoFocus
                    style={{ width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                  />
                </div>
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '6px' }}>Password</label>
                  <input
                    type="password" value={password} onChange={e => setPassword(e.target.value)}
                    required
                    style={{ width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                  />
                </div>
                <button
                  type="submit" disabled={loading}
                  style={{ width: '100%', padding: '10px', background: '#fff', color: '#185FA5', border: '1px solid #185FA5', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
                >
                  {loading ? 'Signing in...' : 'Sign in with password'}
                </button>
              </form>
            )}
          </>
        )}
      </div>
    </div>
  );
}
